import { type LightComponent, ELightType } from '@seddi/scene';

import { LightRenderable } from '../renderables/lightRenderable';

const ColorDefault = { x: 1, y: 1, z: 1 };

export const update = (renderable: LightRenderable, nextProps: LightComponent): boolean => {
  const light = renderable.light;

  const colorRGB = nextProps.spectrum ?? ColorDefault;
  light.color.setRGB(colorRGB.x, colorRGB.y, colorRGB.z);

  const intensity = nextProps.power || 1;
  light.intensity = intensity;

  const visible = nextProps.isEnabled || true;
  light.visible = visible;

  const castShadows = !!nextProps.castShadow;
  light.castShadow = castShadows;

  switch (nextProps.kind) {
    case ELightType.Directional: {
      break;
    }
    default:
    case ELightType.Point: {
      // const lightx = <Three.PointLight>light;
      // lightx.distance = 100;
      // lightx.decay = 2;
      break;
    }
    case ELightType.Area: {
      // const lightx = <Three.RectAreaLight>light;
      // this.helper = new Mesh(helpers.plane, material);
      // this.helper.add(new Mesh(helpers.plane, Materials.LightBack));
      // const { size } = nextProps;
      // if (light.width !== undefined) {
      //   light.width = size ? size.x : 1;
      //   helper.scale.x = light.width;
      // }
      // if (light.height !== undefined) {
      //   light.height = size ? size.y : 1;
      //   helper.scale.y = light.height;
      // }
      break;
    }
  }

  return true;
};

// let material;
// if (this.helper) {
//   material = this.helper.material;
//   this.remove(this.helper);
// } else {
//   material = Materials.Helper.clone();
//   material.isClone = true;
// }
